fragment LeadResearchSummaryFragment on EntitySummaryLeadResearch {
    id
    entityId
    status
    summary
    userRating
    createdTime
    leadFit
    leadFitLabel
    leadFitReasons {
        text
        sentiment
        body
    }
    fields {
        key
        label
        value
    }
    companyOverview {
        headline
        body
    }
    canRefresh
}
